import { render, staticRenderFns } from "./ApprovalSteps.vue?vue&type=template&id=16a50718&scoped=true"
import script from "./ApprovalSteps.vue?vue&type=script&lang=js"
export * from "./ApprovalSteps.vue?vue&type=script&lang=js"
import style0 from "./ApprovalSteps.vue?vue&type=style&index=0&id=16a50718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a50718",
  null
  
)

export default component.exports